export type NewsArticle = {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  cover: string;
  paragraphs: string[];
};

export const newsCategories = ["全部", "影片资讯", "幕后花絮", "影展动态", "观影指南"];

export const newsArticles: NewsArticle[] = [
  {
    id: "se-jie-4k-restore",
    title: "《色戒》高清修复版重映：那些被忽略的光与布料",
    date: "2026-10-12",
    category: "影片资讯",
    summary:
      "修复团队用两年时间重新扫描原始底片，这次重映最直观的变化不是清晰度，而是暗部层次与布料质感。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20vintage%20film%20reels%20and%20a%20magnifying%20glass%20on%20a%20wooden%20table%2C%20warm%20amber%20lamp%20light%2C%20deep%20navy%20shadows%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=900&height=560&seq=news-cover-restore&orientation=landscape",
    paragraphs: [
      "这次高清修复最常被提到的词是「层次」。修复团队在访谈中表示，他们并没有对画面做额外的锐化，而是尽量还原底片本身的宽容度，让原本糊成一片的暗部重新有了细节。",
      "最明显的差别出现在室内夜戏。旗袍的织纹、窗帘的褶皱、桌面反光的形状，这些在旧版本里几乎被压成纯黑的区域，现在可以看见细微的明暗过渡。",
      "声音部分同样做了处理。修复版保留了原始的混音比例，只清理了底噪，没有加入任何新的环绕效果。「我们希望观众听到的是当年的声音，而不是今天的。」修复师在采访中说。",
      "重映采用分批放映的方式，部分场次会附带主创访谈的纪录短片。对第一次在大银幕上看这部作品的观众来说，这可能是最接近原始放映状态的一次机会。",
    ],
  },
  {
    id: "se-jie-qipao-design",
    title: "从一件旗袍说起：造型如何参与叙事",
    date: "2026-10-08",
    category: "幕后花絮",
    summary: "全片二十余套旗袍并非单纯的年代还原，颜色的深浅变化几乎对应着人物处境的转折。",
    cover:
      "https://readdy.ai/api/search-image?query=detail%20shot%20of%20elegant%201940s%20silk%20qipao%20fabrics%20with%20delicate%20patterns%20draped%20on%20a%20tailor%20table%2C%20warm%20soft%20window%20light%2C%20muted%20amber%20and%20navy%20tones%2C%20editorial%20still%20life&width=900&height=560&seq=news-cover-qipao&orientation=landscape",
    paragraphs: [
      "服装设计在这部影片里承担了大量叙事功能。人物的每一次重要转折，几乎都伴随着一套新衣服的出现。",
      "早期场景中的旗袍颜色偏浅，剪裁也相对宽松，带有一种刻意的学生气。随着人物进入更复杂的处境，布料变得更挺、颜色更深，领口和肩线的处理也逐渐收紧。",
      "值得注意的是那些看似不起眼的配件。一枚胸针、一只手表、甚至袖口的一粒扣子，都对应着特定的场景与人物关系。",
      "造型组在接受采访时提到，他们做了大量的面料测试，只为了在特定灯光下得到准确的反射效果。「在那种光线里，布料是会说话的。」",
    ],
  },
  {
    id: "autumn-film-list",
    title: "十月观影清单：十部适合深夜看的电影",
    date: "2026-10-05",
    category: "观影指南",
    summary: "从港产悬疑到人文纪录片，这份清单按情绪而不是类型排列，适合一个人安静地看完。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20night%20living%20room%20with%20a%20projector%20casting%20warm%20light%20on%20a%20blank%20wall%2C%20soft%20blankets%2C%20deep%20navy%20shadows%2C%20cinematic%20editorial%20photography&width=900&height=560&seq=news-cover-autumnlist&orientation=landscape",
    paragraphs: [
      "有些电影适合周末下午，有些只能在深夜看。这份清单属于后者：它们节奏不快，但会让人在片尾字幕结束后仍坐一会儿。",
      "如果你想要一点紧张感，《雾港疑云》和《空房间》是很好的选择——封闭空间、有限人物、大量依靠声音推进。前者的雾，后者的走廊，都会在关掉屏幕之后留在脑子里。",
      "需要一点温柔的时候，可以看《海岸线》或《青山老》。这两部作品都不急着讲完一个故事，它们更像是在陪观众待一段时间。",
      "至于《山海之间》和《星辰之下》，建议把手机放到另一个房间。这两部纪录片最好的部分都在那些几乎什么都没发生的镜头里。",
      "清单的最后留给了《色戒》。不是因为它的名气，而是因为它值得在一个不会被打断的夜里，从头到尾完整地看一遍。",
    ],
  },
  {
    id: "hidden-city-worldbuilding",
    title: "《隐匿之城》的世界观是怎么搭起来的",
    date: "2026-09-29",
    category: "幕后花絮",
    summary: "编剧团队先写了一本没人会看到的手册，规定了这座城市的每一条规则，然后才开始写剧本。",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20architectural%20model%20of%20a%20dense%20foggy%20city%20on%20a%20design%20studio%20table%2C%20geometric%20light%20beams%2C%20deep%20navy%20and%20amber%20accents%2C%20editorial%20photography&width=900&height=560&seq=news-cover-worldbuilding&orientation=landscape",
    paragraphs: [
      "很多科幻剧集的失败，都是从世界观松散开始的。《隐匿之城》的做法刚好相反：先立规矩，再讲故事。",
      "据主创透露，团队在正式写剧本之前，先完成了一本近百页的设定手册，内容包括城市的地理边界、居民的进入方式、记忆的运作机制，以及三条不可违反的禁令。",
      "这本手册从未公开，但它保证了十二集里没有出现任何自相矛盾的设定。观众在第第八集产生的疑问，大多能在后面的细节里找到伏笔。",
      "美术团队则按照手册反向搭建场景，很多在镜头里只出现几秒的空间，都做了完整的结构设计。",
    ],
  },
  {
    id: "film-festival-winners",
    title: "亚洲电影展公布获奖名单，三部华语作品入选",
    date: "2026-09-24",
    category: "影展动态",
    summary: "本届影展评审团将最佳影片授予一部低成本单场景作品，纪录片单元同样出现了意外结果。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20empty%20cinema%20auditorium%20with%20warm%20stage%20light%20and%20deep%20navy%20seats%2C%20soft%20spotlight%20on%20a%20single%20podium%2C%20cinematic%20editorial%20photography&width=900&height=560&seq=news-cover-festival&orientation=landscape",
    paragraphs: [
      "本届影展的评审结果被认为是近年来最「不看流量」的一次。最佳影片授予了一部几乎全部在火车站候车厅完成拍摄的低成本作品。",
      "评审团在致辞中提到，这部影片「用最有限的空间讨论了最普遍的情感」，并特别肯定了它对白写作的完成度。",
      "纪录片单元的竞争同样激烈。《山海之间》凭借两年的四季跟拍获得评审团特别奖，评语强调它对「不干预」的坚持。",
      "此外，一部四十二分钟的短片拿下了最佳新导演，成为本届影展讨论度最高的话题之一。",
    ],
  },
  {
    id: "sound-design-talk",
    title: "声音是第二摄影机：与《深海回声》声音指导的对谈",
    date: "2026-09-18",
    category: "幕后花絮",
    summary: "全片几乎没有配乐，所有的紧张感来自水压、呼吸和一段被反复播放的声呐录音。",
    cover:
      "https://readdy.ai/api/search-image?query=analog%20sound%20mixing%20console%20with%20glowing%20warm%20indicators%20in%20a%20dark%20studio%2C%20deep%20navy%20shadows%2C%20cinematic%20detail%20shot%2C%20shallow%20depth%20of%20field&width=900&height=560&seq=news-cover-sound&orientation=landscape",
    paragraphs: [
      "「我们一开始就决定不用配乐。」声音指导在访谈中说，「因为在水下，音乐会变成一种作弊。」",
      "影片的声音层由三部分构成：真实的舱内环境声、经过处理的低频水压声，以及那段虚构的声呐信号。前两者负责建立空间，后者负责制造疑问。",
      "最精细的工作是呼吸。不同的舱室、不同的深度、不同的人物状态，呼吸的混响都被单独设计过。观众未必能听出来，但会觉得不舒服——这正是团队想要的。",
      "那段声呐信号其实是由一段人声反向处理后叠加生成的。声音指导笑着说：「所以你们觉得它像人说话，是对的。」",
    ],
  },
  {
    id: "how-to-read-film-meta",
    title: "看懂影片资料页：导演、片长与版本到底差在哪",
    date: "2026-09-11",
    category: "观影指南",
    summary: "同样是「158分钟」，不同版本可能完全不是一回事。这篇整理了几个容易被忽略的字段。",
    cover:
      "https://readdy.ai/api/search-image?query=open%20notebook%20with%20handwritten%20notes%20and%20a%20film%20clapperboard%20on%20a%20warm%20wooden%20desk%2C%20soft%20morning%20light%2C%20navy%20and%20amber%20tones%2C%20editorial%20still%20life&width=900&height=560&seq=news-cover-metadata&orientation=landscape",
    paragraphs: [
      "很多观众在查资料时会困惑：为什么同一部电影在不同网站上，片长能差出十几分钟？",
      "原因通常有三种：一是不同地区的发行版本长度不同；二是有些版本包含片头片尾的字幕卡；三是修复版可能补回了当年被剪掉的段落。",
      "导演字段也需要注意。有些作品标注的是「导演」，有些标注「总导演」，在剧集里还可能出现分集导演，这些都不是同一个概念。",
      "我们在影片详情页尽量标注了版本信息。如果某个字段无法确认，宁可留空，也不会随便填一个看起来合理的数字。",
    ],
  },
  {
    id: "long-night-interview",
    title: "《长夜将尽》导演访谈：我不想拍一个破案故事",
    date: "2026-09-03",
    category: "影片资讯",
    summary: "关于那场十七分钟的雨戏、关于为什么删掉了一半的推理线，导演韩牧聊了聊他的取舍。",
    cover:
      "https://readdy.ai/api/search-image?query=director%20chair%20and%20a%20monitor%20on%20a%20rainy%20night%20film%20set%2C%20wet%20asphalt%20reflections%2C%20deep%20navy%20tones%20with%20warm%20practical%20lights%2C%20cinematic%20editorial%20photography&width=900&height=560&seq=news-cover-director&orientation=landscape",
    paragraphs: [
      "「如果观众看完只记得凶手是谁，那我就失败了。」导演韩牧在访谈开头这样说。",
      "影片最初的剧本里有完整的推理链条，甚至拍了一场长达八分钟的案情复盘。成片里，这场戏被整段删掉了。",
      "留下的是一场雨戏：老刑警站在便利店门口，没有台词，只是等雨停。这场戏拍了十七分钟，最后剪进成片不到三分钟。",
      "「我想拍的是一个人怎么面对自己没做好的事。案件只是一个容器。」他说。",
    ],
  },
  {
    id: "documentary-shooting-notes",
    title: "在山里待了两年：纪录片摄制组的日常",
    date: "2026-08-27",
    category: "幕后花絮",
    summary: "没有剧本、没有旁白、也没有补拍机会，摄制组靠什么决定什么时候开机？",
    cover:
      "https://readdy.ai/api/search-image?query=documentary%20camera%20on%20a%20tripod%20in%20a%20misty%20mountain%20village%20at%20dawn%2C%20wooden%20roofs%2C%20warm%20sunrise%20haze%2C%20navy%20blue%20mist%2C%20editorial%20photography&width=900&height=560&seq=news-cover-docshoot&orientation=landscape",
    paragraphs: [
      "拍纪录片最难的部分，是知道什么时候该关机。",
      "《山海之间》的摄制组在山里住了两年，最长的一次连续待了四个月。设备很简单：两台机器、三支镜头、一套收音。",
      "导演程野说，前三个月几乎没拍到什么可用的素材。「你得先让他们习惯你在那儿，这件事急不来。」",
      "真正开始拍摄，是在第四个月的一场雨后。老人蹲在屋檐下修一把锄头，什么也没说，修了整整四十分钟。这个镜头最后成了影片的开场。",
    ],
  },
  {
    id: "wuxia-action-design",
    title: "不用威亚的武侠片：动作设计的另一种可能",
    date: "2026-08-19",
    category: "影片资讯",
    summary: "《第一剑》全片没有一场空中打斗，动作设计把重心放在重量、呼吸和脚下。",
    cover:
      "https://readdy.ai/api/search-image?query=blurred%20motion%20of%20a%20wooden%20practice%20sword%20in%20a%20dim%20training%20hall%2C%20dust%20in%20warm%20light%20beam%2C%20deep%20navy%20shadows%2C%20cinematic%20editorial%20photography&width=900&height=560&seq=news-cover-action&orientation=landscape",
    paragraphs: [
      "在大多数武侠片里，动作是轻的。《第一剑》反着来：所有的动作都有重量。",
      "导演雷敬武行出身，坚持实拍长镜头。片中最长的一场对打有六十二秒，中间没有剪辑点。",
      "为了让重量可信，演员提前八个月开始训练，包括负重步法、呼吸控制和真实的兵器对抗。",
      "「观众其实看得出真假。」雷敬说，「你脚离地的那一瞬间，重量就没了。」",
    ],
  },
  {
    id: "streaming-vs-cinema",
    title: "大银幕与小屏幕：同一部电影为什么看起来不一样",
    date: "2026-08-12",
    category: "观影指南",
    summary: "画幅、亮度、环境光与观看距离，四个变量决定了你在家看片时损失的到底是什么。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20cinema%20screen%20glowing%20soft%20white%20in%20a%20dark%20theater%20with%20a%20few%20empty%20navy%20seats%2C%20minimal%20geometric%20composition%2C%20cinematic%20editorial%20photography&width=900&height=560&seq=news-cover-screens&orientation=landscape",
    paragraphs: [
      "同一部电影，在影院和在家看，差别远不止屏幕大小。",
      "首先是画幅。很多作品会针对不同放映规格做画幅调整，在家用电视上可能会看到上下留黑边，或者画面被裁切。",
      "其次是亮度与环境光。影院的观影环境接近全黑，画面的暗部层次能被完整看到；而在有环境光的客厅里，暗部很容易糊在一起。",
      "最后是观看距离。距离决定了画面占据你视野的比例，也决定了你能否注意到导演在构图边缘放的那些细节。",
      "所以如果你打算认真看一部电影，尽量关灯、把屏幕调到你舒服的最大尺寸，然后把手机放远一点。",
    ],
  },
  {
    id: "october-new-titles",
    title: "十月新片速览：六部值得留意的作品",
    date: "2026-10-15",
    category: "影片资讯",
    summary: "本月上线的作品中，类型分布相当分散，从时间循环科幻到家庭喜剧都有。",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20film%20postcards%20and%20a%20vintage%20calendar%20on%20a%20warm%20beige%20desk%2C%20soft%20daylight%2C%20navy%20and%20orange%20accents%2C%20editorial%20flat%20lay%20photography&width=900&height=560&seq=news-cover-october&orientation=landscape",
    paragraphs: [
      "本月的片单比预想中更有趣，至少有三部作品在类型上做了明显尝试。",
      "《永恒的一天》用时间循环的框架讲了一个很私人的故事，科幻设定只是外壳。《第一剑》则把武侠片的动作逻辑整个翻新了一遍。",
      "如果想轻松一点，《节日》是个安全的选择，适合和家人一起看。",
      "纪录片方面，《星辰之下》和《山海之间》都值得安排一个安静的晚上。前者关于星空，后者关于土地，但讲的是同一件事：人怎么和自己所处的环境相处。",
    ],
  },
];